module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dcBQC"))).then(() => parcelRequire('ikE14'));